// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".carousel[data-v-6cbbc5c6]{margin-top:10px}.carousel .el-carousel__item h3[data-v-6cbbc5c6]{color:#475669;font-size:14px;line-height:150px;margin:0;opacity:.75}.carousel .el-carousel__item[data-v-6cbbc5c6]:nth-child(2n){background-color:#99a9bf}.carousel .el-carousel__item[data-v-6cbbc5c6]:nth-child(odd){background-color:#d3dce6}.carousel .image[data-v-6cbbc5c6]{height:100%;width:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
